// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1C90E","label":"Completed_label__2GIDs"};